import { useRuntime } from './useRuntime';

export const usePath = () => {
  const {
    page: { path },
  } = useRuntime();

  return {
    path,
    isHomepage: /^index\.?/.test(path),
    isRatgeberPage:
      /^mietwagen-ratgeber/.test(path) || /^guide-location-voiture/.test(path),
    isRatgeberAzPage:
      /^mietwagen-ratgeber\/a-z/.test(path) ||
      /^guide-location-voiture\/a-z/.test(path),
    isRatgeberDestinationPage:
      /^mietwagen-ratgeber\/[^/]+\/reise-tipps/.test(path) ||
      /^mietwagen-ratgeber\/[^/]+\/reise-infos/.test(path),
    isMallorcaPage: /^mietwagen-mallorca/.test(path),
  };
};
